import Button from "components/button/button";
import {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";
import { FaPlus } from "react-icons/fa";
import { useLanguages } from "redux/modules/languages/hook";
import Flag from "react-world-flags";
import InputRowItem from "./InpurRowItem";
import { DndContext, closestCorners } from '@dnd-kit/core'
import { arrayMove, SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { useTranslation } from "react-i18next";
import { currentLang } from "utils/utils";


export default forwardRef(function LanguagePicker(
  {
    labelClass = "text-sm font-bold text-darkerGray leading-4",
    innerLabelClass = "text-xs font-semibold color-select-label leading-3.5 absolute left-4.5 top-4",
    formContainer = "form-input-container",
    className = "",
    label = "",
    otherLabel = "",
    height = 60,
    innerLabel,
    optional = false,
    errorMessages,
    onChange,
    state,
  },
  ref
) {
  const {t} = useTranslation();
  let currLang = currentLang();
  const { languages } = useLanguages();
  const initialValue = useMemo(() => {
    const _langs = {};
    const _levels = {};
    const _inIds = [];

    if (Array.isArray(state)) {
      state.forEach((lang) => {
        const currentLang = languages.find((l) => l.id === lang.lang_id);
        console.log("currentLang: ", currentLang);
        const hasDuplicates = () => {
          const langLength = languages.filter(
            (item) => item.name === currentLang.name
          ).length;

          return langLength > 1;
        };

        const langInfo = {
          label: hasDuplicates()
            ? `${currentLang?.[currLang] || currentLang?.name} ${currentLang?.shortName}`
            : (currentLang?.[currLang] || currentLang?.name),
          value: currentLang.id,
          // icon: <Flag code={currentLang.countryCode} height={16} width={16} />,
          orderNumber: lang.orderNumber,
        };

        _levels[currentLang.id] = {
          label: t(lang.level),
          value: lang.level,
        };
        _langs[currentLang.id] = langInfo;
        if (currentLang.id) _inIds.push(currentLang.id);
      });
    }

    if (_inIds.length === 0) {
      _inIds.push(crypto.randomUUID());
    }

    return {
      selectedLangs: _langs,
      selectedLangLevels: _levels,
      inputRowIds: _inIds,
    };
  }, [state, languages,t,currLang]);

  const [selectedOption, setSelectedOption] = useState(
    initialValue.selectedLangs
  );
  const [selectedLevel, setSelectedLevel] = useState(
    initialValue.selectedLangLevels
  );
  const [inputRows, setInputRow] = useState(initialValue.inputRowIds);
  const [shouldUpdate, setShouldUpdate] = useState(false);

  

  const [listOptions, setOptions] = useState([]);

  const options = useMemo(() => {
    return languages.map((lang) => {
      const hasDuplicates = () => {
        const langLength = languages.filter(
          (item) => item.name === lang.name
        ).length;

        return langLength > 1;
      };

      return {
        label: hasDuplicates() ? `${lang?.[currentLang()] || lang.name} ${lang.shortName}` : lang?.[currentLang()] || lang.name,
        value: lang.id,
        // icon: <Flag code={lang.countryCode} height={16} width={16} />,
      };
    });
  }, [languages]);

  // useEffect(() => {
  //   let lang = languages.map((lang) => {
  //     const hasDuplicates = () => {
  //       const langLength = languages.filter(
  //         (item) => item.name === lang.name
  //       ).length;

  //       return langLength > 1;
  //     };

  //     return {
  //       label: hasDuplicates() ? `${lang?.[currentLang()] || lang.name} ${lang.shortName}` : lang?.[currentLang()] || lang.name,
  //       value: lang.id,
  //       // icon: <Flag code={lang.countryCode} height={16} width={16} />,
  //     };
  //   });
  //   setOptions(lang);
  // }, [languages]);

  useEffect(() => {
    const options = languages
      .filter(
        (lang) => !state.some((item) => item.lang_id === lang.id)
      )
      .map((lang) => ({
        label: lang?.[currentLang()] || lang.name,
        value: lang.id,
        // icon: <Flag code={lang.countryCode} height={16} width={16} />,
      }));

    setOptions(options);
  }, [languages, state]);

  useEffect(() => {
    if (inputRows.length === 0) {
      setInputRow([crypto.randomUUID()]);
    }
  }, [inputRows]);

  useEffect(() => {
    if (shouldUpdate) {
      onChange?.(getValues());
      setShouldUpdate(false);
    }
  }, [shouldUpdate, onChange]);

  const handleAddRow = () => {
    setInputRow((s) => [...s, crypto.randomUUID()]);
  };

  const getValues = useCallback(() => {
    const values = [];
    for (const [index, inputId] of inputRows.entries()) {
      const lang = selectedOption[inputId];
      const level = selectedLevel[inputId];

      if (!!lang) {
        const langInfo = {
          lang_id: lang.value,
          level: level?.value,
          orderNumber: index + 1,
        };

        values.push(langInfo);
      }
    }
    return values;
  }, [selectedOption, selectedLevel, inputRows]);

  const handleRemoveRow = (inputId) => {
    const current = JSON.parse(JSON.stringify(inputRows));
    const newRows = current.filter((item) => item !== inputId);

    const currentSelectedLang = selectedOption;
    const currentSelectedLevel = selectedLevel;

    console.log({
      currentSelectedLang,
      currentSelectedLevel,
    });

    let getRemove = options.find(item => item?.value === currentSelectedLang[inputId]?.value);
    if(getRemove){
      setOptions(prev =>
        [...prev, getRemove].sort((a, b) =>
          a.label.localeCompare(b.label)
        )
      );
    }

    if (currentSelectedLang[inputId]) {
      delete currentSelectedLang[inputId];
      setSelectedOption(currentSelectedLang);
    }
    if (currentSelectedLevel[inputId]) {
      delete currentSelectedLevel[inputId];
      setSelectedLevel(currentSelectedLevel);
    }
    
    

    setInputRow(newRows);
    setShouldUpdate(true);
  };

  const padding = innerLabel ? { paddingTop: 20 } : {};
  // const customStyles = {
  //   control: (styles) => {
  //     return {
  //       ...styles,
  //       backgroundColor: "white",
  //       borderColor: errorMessages ? "red" : "#dfdfdf",
  //       // height: height,
  //       borderRadius: 6,
  //       minHeight: height,
  //       boxShadow: "none",
  //       "&:hover": {
  //         border: "1px solid #dfdfdf !important",
  //         cursor: "pointer",
  //       },
  //       paddingLeft: 8,
  //       ...padding,
  //     };
  //   },
  //   option: (provided) => {
  //     return {
  //       ...provided,
  //       padding: "8px 18px",
  //       zIndex: 2,
  //     };
  //   },
  //   placeholder: (defaultStyles) => {
  //     return {
  //       ...defaultStyles,
  //       color: "#aaaaaa",
  //     };
  //   },
  //   menu: (base) => {
  //     return {
  //       ...base,
  //       zIndex: 9999,
  //     };
  //   },
  //   menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  //   menuList: (base) => ({
  //     ...base,
  //     "::-webkit-scrollbar": {
  //       width: "4px",
  //       height: "0px",
  //     },
  //     "::-webkit-scrollbar-track": {
  //       background: "rgba(255, 255, 255, 0.1)",
  //       borderRadius: "10px",
  //     },
  //     "::-webkit-scrollbar-thumb": {
  //       background: "#d1d1d1",
  //       borderRadius: "10px",
  //     },
  //     "::-webkit-scrollbar-thumb:hover": {
  //       background: "#555",
  //     },
  //   }),
  // };


  const handleDragEnd = (e) => {
    const { active, over } = e;
    if(active.id === over.id) return;

    setInputRow(s => {
      const origPosition = s.findIndex(item => item === active.id);
      const newPosition = s.findIndex(item => item === over.id);

      return arrayMove(s, origPosition, newPosition);
    });
    setShouldUpdate(true);
  };

  useImperativeHandle(
    ref,
    () => ({
      getValues,
    }),
    [getValues]
  );

  const updateSelected = (item)=>{
    setOptions(listOptions.filter(opt => opt.value !== item.value));
  }



  return (
    <>
      <div className={`${formContainer} cursor-pointer relative`}>
        {label && (
          <label htmlFor={label} className={labelClass}>
            {label}
            {optional && <span className="font-normal">{" (optional)"}</span>}
            {otherLabel && (
              <span className="font-normal leading-4">
                <br />
                {otherLabel}
              </span>
            )}
          </label>
        )}

        {innerLabel && (
          <label
            htmlFor={innerLabel}
            className={innerLabelClass}
            style={{ zIndex: 1 }}
          >
            {innerLabel}
          </label>
        )}

        <div className="hidden md:flex flex-row items-center gap-3 font-semibold text-xs text-neutral-500 mb-2">
          <div className={"mt-14 md:mt-[1.375rem] w-[0.6875rem]"}></div>
          <div className="flex-1">{t("language")}</div>
          <div className="flex-1">{t("level")}</div>
          <div className="w-[25px]"></div>
        </div>

        
        <DndContext collisionDetection={closestCorners} onDragEnd={handleDragEnd}>
          <div className="flex flex-col w-full gap-4">
            <SortableContext items={inputRows} strategy={verticalListSortingStrategy}>
              {inputRows.map((inputId, index) => {
                return (
                  <InputRowItem
                    label={label}
                    setSelectedLevel={setSelectedLevel}
                    onRemoveRow={handleRemoveRow}
                    className={className}
                    selectedLevel={selectedLevel}
                    inputId={inputId}
                    rowIndex={index}
                    // customStyles={customStyles}
                    options={listOptions}
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                    setShouldUpdate={setShouldUpdate}
                    updateSelected={updateSelected}
                    errorMessages={errorMessages}
                    // innerLabel
                  />
                );
              })}
            </SortableContext>
          </div>
        </DndContext>


        {/* {errorMessage && (
          <p className="input-error-message mt-2 -mb-1">* {errorMessage}</p>
        )} */}
      </div>

      <Button
        buttonName={t('addAnotherLang')}
        buttonTextClass="text-sm text-white font-semibold flex items-center"
        iconPosition="left"
        icon={<FaPlus className="mr-3" />}
        buttonRadius="6px"
        buttonClass="relative py-4 px-9 bg-lightBlack"
        onClick={handleAddRow}
      />
    </>
  );
});

